import { render, staticRenderFns } from "./WebShell.vue?vue&type=template&id=b088a69a&scoped=true&"
import script from "./WebShell.vue?vue&type=script&lang=js&"
export * from "./WebShell.vue?vue&type=script&lang=js&"
import style0 from "./WebShell.vue?vue&type=style&index=0&id=b088a69a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b088a69a",
  null
  
)

export default component.exports